import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";



export const userLogin = (email, password) => async (dispatch) => {
    try {
        const signedinUser = firebase.signUser(email, password);
        if (signedinUser) {
            dispatch({
                type: actionTypes.USER_LOGIN,
                payload: {
                    email: email,
                    profileExist: true,
                }
            });
        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};

export const userLogout = () => async (dispatch) => {
    try {
        firebase.signoutUser().then(() => {
            dispatch({
                type: actionTypes.USER_LOGOUT,
                payload: {
                    currentUser: "",
                }
            })
        })
    } catch (err) {
        console.error(err);
    }
};

export const userSignup = (provider, userFN, userLN, userAdd, userEmail, userContact, userPass) => async (dispatch) => {
    try {
        const signedinUser = firebase.registerUser(provider, userFN, userLN, userAdd, userEmail, userContact, userPass);
        if (signedinUser) {
            dispatch({
                type: actionTypes.USER_REGISTER,
                payload: {
                    email: userEmail,
                }
            });
        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};

export const googleLogin = () => async (dispatch) => {
    try {
        const signedinUser = firebase.googleSignin();
        if (signedinUser) {
            firebase.getDocument(signedinUser.uid).then((data) => {
                if (data.data()) {
                    dispatch({
                        type: actionTypes.GOOGLE_LOGIN,
                        payload: {
                            email: signedinUser.email,
                            profileExist: true,

                        }
                    });
                } else {
                    dispatch({
                        type: actionTypes.GOOGLE_LOGIN,
                        payload: {
                            email: signedinUser.email,
                            profileExist: false,
                        }
                    });
                }
            })

        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};

export const facebookLogin = () => async (dispatch) => {
    try {
        const signedinUser = firebase.facebookSignin();
        if (signedinUser) {
            firebase.getDocument(signedinUser.uid).then((data) => {
                if (data.data()) {
                    dispatch({
                        type: actionTypes.USER_LOGIN,
                        payload: {
                            email: signedinUser.email,
                            profileExist: true,

                        }
                    });
                } else {
                    dispatch({
                        type: actionTypes.USER_LOGIN,
                        payload: {
                            email: signedinUser.email,
                            profileExist: false,
                        }
                    });
                }
            })

        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};

export const currentUser = (uid, email) => async (dispatch) => {
    try {
        if (uid) {
            firebase.getDocument(uid).then((data) => {
                if (data.data()) {
                    dispatch({
                        type: actionTypes.CURRENT_USER,
                        payload: {
                            email: email,
                            profileExist: true,
                            currentUser: data.data()
                        }
                    });
                } else {
                    dispatch({
                        type: actionTypes.CURRENT_USER,
                        payload: {
                            email: email,
                            profileExist: false,
                            currentUser: {}
                        }
                    });
                }
            })
        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};


export const registerProfile = (userFN, userLN, userAdd, userEmail, userContact) => async (dispatch) => {
    try {
        const signedinUser = firebase.editProfile(userFN, userLN, userAdd, userEmail, userContact);
        if (signedinUser) {
            dispatch({
                type: actionTypes.USER_LOGIN,
                payload: {
                    email: userEmail,
                    profileExist: true
                }
            });
        } else {
            console.log("false");
        }
    } catch (err) {
        console.error(err);
    }
};

export const getNotifications = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getNotifications(), notif => {
            var notifications = [];
            notif.forEach((doc) => {
                notifications.unshift({ ...doc.data(), id: doc.id })
            });
            if (notifications.length > 0) {
                dispatch({
                    type: actionTypes.GET_NOTIFICATIONS,
                    payload: {
                        notifications: notifications,
                        notificationEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_NOTIFICATIONS,
                    payload: {
                        notifications: notifications,
                        notificationEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}